"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _checkboxChecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-checked2"));
var _checkboxUnchecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-unchecked2"));
var _checkboxPartial = _interopRequireDefault(require("cccisd-icons/svg/checkbox-partial2"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _List = _interopRequireDefault(require("./List.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MetricsPicker = function MetricsPicker(props) {
  var options = props.options,
    field = props.field,
    form = props.form;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _field$value = field.value,
    types = _field$value.types,
    list = _field$value.list;

  // create sets just to perform better with the huge list of metrics
  var _useMemo = (0, _react.useMemo)(function () {
      var calcListSet = new Set(list);
      return {
        listSet: calcListSet,
        metricsCount: options.reduce(function (obj, option) {
          var selected = 0;
          if (types.includes(option.value)) {
            selected = option.list.length;
          } else {
            selected = option.list.reduce(function (cnt, metric) {
              return cnt + (calcListSet.has(metric.id) ? 1 : 0);
            }, 0);
          }
          obj[option.value] = {
            total: option.list.length,
            selected: selected
          };
          return obj;
        }, {})
      };
    }, [options, types, list]),
    listSet = _useMemo.listSet,
    metricsCount = _useMemo.metricsCount;
  var toggleExpanded = function toggleExpanded(id) {
    setExpanded((0, _xor2["default"])(expanded, [id]));
  };
  var toggleList = function toggleList(id) {
    var newList = (0, _xor2["default"])(list, Array.isArray(id) ? id : [id]);
    var newListSet = new Set(newList);
    var customTypes = options.filter(function (option) {
      return option.list.some(function (metric) {
        return !newListSet.has(metric.id);
      });
    }).map(function (option) {
      return option.value;
    });
    var allTypes = options.filter(function (option) {
      return option.list.length > 0 && option.list.every(function (metric) {
        return newListSet.has(metric.id);
      });
    }).map(function (option) {
      return option.value;
    });
    var nullTypes = options.filter(function (option) {
      return option.list.length > 0 && option.list.every(function (metric) {
        return !newListSet.has(metric.id);
      });
    }).map(function (option) {
      return option.value;
    });
    form.setFieldValue(field.name, _objectSpread(_objectSpread({}, field.value), {}, {
      list: newList,
      types: (0, _union2["default"])((0, _difference2["default"])(types, customTypes, nullTypes), allTypes)
    }));
  };
  var toggleTypes = function toggleTypes(id) {
    var newState = !types.includes(id);
    var typeMetrics = options.find(function (option) {
      return option.value === id;
    }).list.map(function (item) {
      return item.id;
    });
    var newList = newState ? (0, _union2["default"])(list, typeMetrics) : (0, _difference2["default"])(list, typeMetrics);
    form.setFieldValue(field.name, _objectSpread(_objectSpread({}, field.value), {}, {
      types: (0, _xor2["default"])(types, [id]),
      list: newList
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, options.map(function (option) {
    var isCustom = metricsCount[option.value].selected > 0 && metricsCount[option.value].selected < metricsCount[option.value].total;
    var count = /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].count
    }, "(", metricsCount[option.value].selected, "/", metricsCount[option.value].total, ")");
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.value,
      className: _style["default"].groupWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].group
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].check,
      onClick: function onClick() {
        return toggleTypes(option.value);
      }
    }, function () {
      if (types.includes(option.value)) {
        return /*#__PURE__*/_react["default"].createElement(_checkboxChecked["default"], null);
      }
      if (isCustom) {
        return /*#__PURE__*/_react["default"].createElement(_checkboxPartial["default"], null);
      }
      return /*#__PURE__*/_react["default"].createElement(_checkboxUnchecked["default"], null);
    }()), /*#__PURE__*/_react["default"].createElement("label", {
      onClick: function onClick() {
        return toggleExpanded(option.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].expandIcon
    }, expanded.includes(option.value) ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)), option.label), option.tooltip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: option.tooltip
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary"
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], {
      spaceLeft: true
    }))), count), expanded.includes(option.value) && /*#__PURE__*/_react["default"].createElement(_List["default"], {
      list: option.list,
      selected: listSet,
      toggle: toggleList
    }));
  }));
};
MetricsPicker.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  options: _propTypes["default"].array
};
var _default = exports["default"] = MetricsPicker;